import {Button, Grid, Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {BoundCardButtonProps} from './BoundCardButton.types'

const BoundCardButton: React.FC<BoundCardButtonProps> = ({
  title,
  subTitle,
  variant,
  titleColor,
  subTitleColor,
  onPress,
  isLoading = false,
  isDisabled = false,
}) => {
  return (
    <Button
      disabled={isDisabled}
      loading={isLoading}
      onPress={onPress}
      size="l"
      type="button"
      variant={variant}
      fullWidth
    >
      <Grid alignItems="center" direction="column" container>
        <Typography color={titleColor} Component={Grid} thickness="medium" variant="body2">
          {title}
        </Typography>
        <Typography color={subTitleColor} Component={Grid} variant="caption1">
          {subTitle}
        </Typography>
      </Grid>
    </Button>
  )
}

BoundCardButton.displayName = 'BoundCardButton'

export default React.memo(BoundCardButton)
